const categoryOptions = {
    newConstruction: [
        { name: "baseWorks", localizationKey: "baseWork", id:"14" },
        { name: "bench", localizationKey: "benches", id: "22" },
        { name: "glass", localizationKey: "doorInstall", id: "26" },
        { name: "lights", localizationKey: "lightSelection", id: "23" },
        { name: "panels", localizationKey: "panelMaterialSelection", id: "17" },
        { name: "measurementVisit", localizationKey: "measurementVisit", id: "31" }
    ],
    renovation: [
        { name: "demolution", localizationKey: "demolutionWork", id: "5" },
        { name: "bench", localizationKey: "benches", id: "22" },
        { name: "glass", localizationKey: "doorInstall", id: "26" },
        { name: "lights", localizationKey: "lightSelection", id: "23" },
        { name: "panels", localizationKey: "panelMaterialSelection", id: "17" },
        { name: "measurementVisit", localizationKey: "measurementVisit", id: "31" }
    ],
    notSelected:[]
};



let initialState = {

    installWanted: undefined,
    installAvailable: "notChecked",
    projectType: "newConstruction",  
    replaceInsulation: false,
    categories: categoryOptions.newConstruction,
    installAvailable: "checkPending",
    estimatedDate: undefined,
    comment:""
}



const installProduct = (state = initialState, action) => {
    switch (action.type) {
        case 'UPDATE_INSTALL_ESTIMATED_DATE':
            return Object.assign({}, state, {
                estimatedDate: action.date
            })
        case 'CHANGE_INSTALL_PROJECT_TYPE':
            return Object.assign({}, state, {
                categories: categoryOptions[action.installProjectType].map(category => Object.assign({}, category)),
                projectType: action.installProjectType
            })
        case 'SET_INSTALL_WANTED':
            return Object.assign({}, state, {
                installWanted: action.installWanted
            })
        case 'INIT_INSTALL_AVAILABILITY_CHECK':
            return Object.assign({}, state, {
                installAvailable: "checking"
            }) 
        case 'CHANGE_INSTALL_DESCRIPTION':
            return Object.assign({}, state, {
                comment: action.installDescription
            })
        case 'CHANGE_DESIRED_DATE':
            return Object.assign({}, state, {
                estimatedDate: action.estimatedDate
            })

        case 'SET_INSTALL_AVALAIBLE':
            let newState;
            if (action.installAvailable === true)
                newState = { installAvailable: "available" };
            else
                newState = { installAvailable: "notAvailable" };        
            return Object.assign({}, state, newState)
        case 'CHANGE_CATEGORY_SELECTION':
            return Object.assign({}, state, {
                categories: state.categories.map(category =>
                    category.name === action.categoryName
                        ? Object.assign({}, category, { selected: action.value })
                        : category
                )
            }) 

        default:
            return state;
    }
}
export default installProduct;




